import { Component, DOCUMENT, Inject, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@sb-tools/typescript/pipes/safe-html.pipe';

@Component({
    selector: 'sb-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [NgClass, TranslateModule, SafeHtmlPipe],
})
export class FooterComponent {
    @Input() communityName?: string;
    @Input() configuration;
    @Input() faqName?: string = '';
    @Input() isForm?: boolean = false;

    originPath: string;

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.originPath = this.document.defaultView.location.origin;
    }
}
